import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  NetworkStatusWithPlanName,
  ResponsiveText,
} from './CareTeamProviderCard.styled';

type NetworkStatusBadgeProps = {
  name?: string;
  providerId: string;
  providerType: string;
  iconColor: string;
};

export const NetworkStatusBadge: React.FC<NetworkStatusBadgeProps> = ({
  name,
  providerId,
  providerType,
  iconColor,
}) => {
  const { t } = useTranslation();

  return (
    <NetworkStatusWithPlanName>
      <IconSymbol
        color={iconColor}
        css={{ aspectRatio: '1/1' }}
        data-auto-testid={`check-network-icon-${providerId}`}
        data-testid={`check-network-icon-${providerId}`}
        icon="check_circle"
        size={16}
        variant="outlined"
      />
      <ResponsiveText
        color="$neutralGray"
        data-auto-testid={`data-card-network-${providerType}-${providerId}`}
        data-testid={`data-card-network-${providerType}-${providerId}`}
        fontWeight="$boldFW"
      >
        {`${t('In-network')}${name ? `: ${name}` : ''}`}
      </ResponsiveText>
    </NetworkStatusWithPlanName>
  );
};
